import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listJuicios:[],
};
export const mutations = {
  GET_JUICIOS({ context }, tipo_juicios) {
    let tipo_juicios_array = [];
    Object.entries(tipo_juicios).forEach(([key, val]) => tipo_juicios_array.push(val));
    return (state.listJuicios = tipo_juicios_array);
  },
};
export const actions = {
  GET_JUICIOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data);
          commit("SET_LOADING", false);
          commit("GET_JUICIOS", response.data.data.tipo_juicios);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_TIPO_JUICIO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SAVE_TIPO_JUICIO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  EDIT_TIPO_JUICIO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("EDIT_TIPO_JUICIO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
      });
    },

    DELETE_TIPO_JUICIO({ commit }, id) { //axios, mandar parametros para post
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.delete(id)//funcion de ApiService
          .then(response => {
            //console.log("store",response);
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    },

};

export const getters = {//leer datos
  listJuicios: state => state.listJuicios,
};
